// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
/**
 *
 * @export
 * @interface DashboardWidgetPayload
 */
export interface DashboardWidgetPayload {
  /**
   * ID of the report template to pin
   * @type {number}
   * @memberof DashboardWidgetPayload
   */
  reportTemplate: number;
  /**
   * Project ID
   * @type {number}
   * @memberof DashboardWidgetPayload
   */
  project: number;
  /**
   * Display order on the dashboard (optional, appended at end if omitted)
   * @type {number}
   * @memberof DashboardWidgetPayload
   */
  sortOrder?: number;
  /**
   * Horizontal grid position for the pinned widget
   * @type {number}
   * @memberof DashboardWidgetPayload
   */
  positionX?: number;
  /**
   * Vertical grid position for the pinned widget
   * @type {number}
   * @memberof DashboardWidgetPayload
   */
  positionY?: number;
  /**
   * Widget width in a 12-column dashboard grid
   * @type {number}
   * @memberof DashboardWidgetPayload
   */
  width?: number;
  /**
   * Widget height in dashboard grid units
   * @type {number}
   * @memberof DashboardWidgetPayload
   */
  height?: number;
  /**
   * Dashboard-specific visualization type for the pinned report
   * @type {string}
   * @memberof DashboardWidgetPayload
   */
  visualizationType?: DashboardWidgetPayloadVisualizationTypeEnum;
  /**
   * Whether the pinned widget appears above or below fixed project dashboard reports
   * @type {string}
   * @memberof DashboardWidgetPayload
   */
  dashboardSection?: DashboardWidgetPayloadDashboardSectionEnum;
}

export function DashboardWidgetPayloadFromJSON(
  json: any
): DashboardWidgetPayload {
  return {
    reportTemplate: json["report_template"],
    project: json["project"],
    sortOrder: !exists(json, "sort_order") ? undefined : json["sort_order"],
    positionX: !exists(json, "position_x") ? undefined : json["position_x"],
    positionY: !exists(json, "position_y") ? undefined : json["position_y"],
    width: !exists(json, "width") ? undefined : json["width"],
    height: !exists(json, "height") ? undefined : json["height"],
    visualizationType: !exists(json, "visualization_type")
      ? undefined
      : json["visualization_type"],
    dashboardSection: !exists(json, "dashboard_section")
      ? undefined
      : json["dashboard_section"],
  };
}

export function DashboardWidgetPayloadToJSON(
  value?: DashboardWidgetPayload
): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    report_template: value.reportTemplate,
    project: value.project,
    sort_order: value.sortOrder,
    position_x: value.positionX,
    position_y: value.positionY,
    width: value.width,
    height: value.height,
    visualization_type: value.visualizationType,
    dashboard_section: value.dashboardSection,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum DashboardWidgetPayloadVisualizationTypeEnum {
  Column = "column",
  Bar = "bar",
  Line = "line",
  Pie = "pie",
  Table = "table",
}
/**
 * @export
 * @enum {string}
 */
export enum DashboardWidgetPayloadDashboardSectionEnum {
  AboveStatic = "above_static",
  BelowStatic = "below_static",
}
